export type AnalyticsReleaseReason = "interaction" | "dwell";

const INTERACTION_EVENTS = [
  "pointermove",
  "scroll",
  "keydown",
  "touchstart",
] as const;

export function scheduleAnalyticsStartup(
  release: (reason: AnalyticsReleaseReason) => void,
  dwellMs = 3000,
): () => void {
  let settled = false;
  let timer: number | undefined;

  const cleanup = () => {
    if (timer !== undefined) window.clearTimeout(timer);
    for (const event of INTERACTION_EVENTS) {
      window.removeEventListener(event, onInteraction);
    }
    document.removeEventListener("visibilitychange", onVisibilityChange);
  };

  const finish = (reason: AnalyticsReleaseReason) => {
    if (settled) return;
    settled = true;
    cleanup();
    release(reason);
  };
  const onInteraction = () => finish("interaction");
  const onVisibilityChange = () => {
    if (document.visibilityState === "visible") finish("interaction");
  };

  for (const event of INTERACTION_EVENTS) {
    window.addEventListener(event, onInteraction, { passive: true, once: true });
  }
  document.addEventListener("visibilitychange", onVisibilityChange);
  timer = window.setTimeout(() => finish("dwell"), dwellMs);

  return cleanup;
}